var $49f018934e6f92c2$exports = {};
$49f018934e6f92c2$exports = {
    "loading": `Nalaganje...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine...`
};


export {$49f018934e6f92c2$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
